import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../utils/FavoritesContext';
import './MovieCard.css';

const MovieCard = ({ movie }) => {
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const { isFavorite, toggleFavorite } = useFavorites();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/movie/${movie.imdbID}`);
    };

    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        toggleFavorite(movie);
    };

    const fallbackImage = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="450" viewBox="0 0 300 450"%3E%3Crect width="300" height="450" fill="%23242424"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="Inter, sans-serif" font-size="20" fill="%238c8c8c"%3ENo Poster%3C/text%3E%3Cpath d="M120 180 L180 180 L180 240 L120 240 Z M135 195 L165 195 L165 210 L135 210 Z M120 255 L180 255 L180 270 L120 270 Z" fill="%23666" /%3E%3C/svg%3E';

    return (
        <div className="movie-card" onClick={handleClick}>
            <div className="movie-card-inner">
                <div className="movie-poster-container">
                    {!imageLoaded && (
                        <div className="skeleton-loader"></div>
                    )}
                    <img
                        src={imageError || movie.Poster === 'N/A' ? fallbackImage : movie.Poster}
                        alt={movie.Title}
                        className={`movie-poster ${imageLoaded ? 'loaded' : ''}`}
                        onError={() => setImageError(true)}
                        onLoad={() => setImageLoaded(true)}
                        loading="lazy"
                    />
                    <div className="movie-overlay">
                        <button
                            className={`favorite-btn ${isFavorite(movie.imdbID) ? 'active' : ''}`}
                            onClick={handleFavoriteClick}
                            aria-label="Add to favorites"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill={isFavorite(movie.imdbID) ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2">
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                            </svg>
                        </button>
                        <div className="overlay-content">
                            <h3 className="movie-title-overlay">{movie.Title}</h3>
                            <p className="movie-year-overlay">{movie.Year}</p>
                            <button className="view-details-btn">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 16v-4M12 8h.01" />
                                </svg>
                                View Details
                            </button>
                        </div>
                    </div>
                </div>
                <div className="movie-info">
                    <h3 className="movie-title">{movie.Title}</h3>
                    <div className="movie-meta">
                        <span className="movie-year">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                <line x1="16" y1="2" x2="16" y2="6" />
                                <line x1="8" y1="2" x2="8" y2="6" />
                                <line x1="3" y1="10" x2="21" y2="10" />
                            </svg>
                            {movie.Year}
                        </span>
                        <span className="movie-type">{movie.Type}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MovieCard;
